module.exports = __webpack_public_path__ + "media/גנן.7e69f1e2.mp3";